import { makeStyles } from '@material-ui/core/styles';

export const useMetricsStyles = makeStyles((theme) => ({
  paper: {
    boxShadow: '0 4px 12px rgba(0,0,0,0.15), 0 2px 4px rgba(0,0,0,0.1)',
    border: 'none',
    borderRadius: 4,
    overflow: 'hidden',
    backgroundColor: '#ffffff',
    height: '100%'
  },
  card: {
    boxShadow: '0 4px 12px rgba(0,0,0,0.15), 0 2px 4px rgba(0,0,0,0.1)',
    border: 'none',
    borderRadius: 4,
    overflow: 'hidden',
    backgroundColor: '#ffffff',
  },
  cardContent: {
    padding: 0,
  },
  header: {
    padding: theme.spacing(2),
    backgroundColor: 'white',
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e0e0e0',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  headerIcon: {
    fontSize: 24,
    color: theme.palette.primary.main,
    transition: theme.transitions.create(['transform'], {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  headerTitle: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '1.125rem',
    letterSpacing: '0.00735em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
  content: {
    padding: theme.spacing(3),
    animation: '$fadeIn 400ms ease-out',
  },
  metricItemPaper: {
    borderRadius: 4,
    boxShadow: '0px 1px 0px 0px rgba(0,0,0,0.2),0px 0px 8px 0px rgba(0,0,0,0.14),0px 0px 0px 0px rgba(0,0,0,0.12)',
    overflow: 'hidden',
    transition: theme.transitions.create(['box-shadow', 'transform'], {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      boxShadow: '0 6px 16px rgba(0,0,0,0.12), 0 3px 6px rgba(0,0,0,0.08)',
      transform: 'translateY(-2px)',
    },
  },
  metricItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: 'white',
    minHeight: 64,
    border: 'none',
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1.5),
    flexShrink: 0,
    backgroundColor: 'transparent',
    transition: theme.transitions.create(['transform'], {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  metricContent: {
    flex: 1,
    minWidth: 0,
  },
  fieldLabel: {
    color: theme.palette.text.secondary,
    fontSize: '1.2rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: theme.spacing(1),
    display: 'block',
    lineHeight: 1.2,
  },
  fieldValue: {
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: 1.2,
    color: theme.palette.text.primary,
  },
  // Legacy styles for backward compatibility
  contentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
  },
  list: {
    padding: 0,
    height: '100%',
    width: '100%',
  },
  listItem: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(0.5, 1),
  },
  listItemIcon: {
    minWidth: 56,
    marginRight: theme.spacing(1.5),
  },
  // Animation classes
  fadeIn: {
    animation: '$fadeIn 600ms ease-out',
  },
  slideInRight: {
    animation: '$slideInRight 400ms ease-out',
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  '@keyframes slideInRight': {
    '0%': {
      opacity: 0,
      transform: 'translateX(30px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
  // Primitive Metrics specific styles
  primitiveMetricsPaper: {
    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
    borderRadius: 12,
    boxShadow: '0 8px 32px rgba(0,0,0,0.12), 0 4px 16px rgba(0,0,0,0.08)',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
}));
